import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getDisplayName } from '../../utils';
import { getFilteredMessages } from './helpers';
import styles from './scroll-to-message-type-anchor.scss';

export const scrollToMessageTypeAnchor = (Item) =>
  class extends PureComponent {
    static displayName = `ScrollToMessageTypeAnchor(${getDisplayName(Item)})`;

    static propTypes = {
      title: PropTypes.string.isRequired,
      forTypes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      messages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      errorMessages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    };

    state = {
      anchorAttribute: undefined,
      extraProps: null,
    };

    static getDerivedStateFromProps(props, state) {
      const { forTypes, messages, errorMessages } = props;
      const { anchorAttribute } = state;

      const filteredErrors = [...getFilteredMessages(forTypes, messages, errorMessages)].map(
        (error) => error.type,
      )[0];
      if (filteredErrors !== anchorAttribute) {
        return {
          ...state,
          anchorAttribute: filteredErrors,
          extraProps: filteredErrors ? { 'data-anchor': filteredErrors } : null,
        };
      }
      return null;
    }

    render() {
      const { extraProps } = this.state;
      return (
        <div {...extraProps} className={styles.scrollToMessageTypeAnchor}>
          <Item {...this.props} />
        </div>
      );
    }
  };

export const mapStateToProps = ({
  messages: {
    app: { messages, errorMessages },
  },
}) => ({
  messages,
  errorMessages,
});

export const ConnectedScrollToMessageTypeAnchor = (Item) =>
  connect(mapStateToProps)(scrollToMessageTypeAnchor(Item));
